<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ data?.quotingSystem?.clientId ? 'Edit' : 'Add' }} Quoting System</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />

<div mat-dialog-content class="add-quoting-system-container">
  <div class="title-1 mt-10 mb-10 font-600 text-neut-50">Company Information</div>
  <form [formGroup]="quotingSystemForm">
    <div class="grid! grid-cols-2 gap-x-20">
      <mat-form-field>
        <mat-label>Company</mat-label>
        <input matInput formControlName="companyName" required />
        @if (quotingSystemForm.controls['companyName'].hasError('required')) {
          <mat-error> Company Name is <strong>required</strong> </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contact</mat-label>
        <input matInput formControlName="contactPhoneNumber" />
        @if (contactPhoneNumber.touched && contactPhoneNumber.hasError('phoneInvalid')) {
          <mat-error> {{ getErrorMessage(contactPhoneNumber.errors) }} </mat-error>
        }
      </mat-form-field>
    </div>
  </form>
</div>

<mat-divider class="mx-20!" />

<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    [disabled]="quotingSystemForm.invalid || quotingSystemForm.pristine || pending()"
    (click)="data?.quotingSystem?.clientId ? editQuotingSystem() : addQuotingSystem()">
    SAVE
  </button>
</mat-dialog-actions>
